import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "navigation-row" }
const _hoisted_2 = { class: "navigation-menu-box" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 2,
  src: _imports_0
}
const _hoisted_6 = { class: "navigation-component-box-links" }
const _hoisted_7 = {
  key: 0,
  class: "navigation-component-hamburger-list"
}
const _hoisted_8 = { class: "navigation-component-hamburger-list-options" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "navigation-component-hamburger-list-options-option-footer" }
const _hoisted_11 = { class: "info-text upper-case-text center-text" }

import axios from 'axios';
import router from '@/router';
import { RouteRecordName } from 'vue-router';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useDebounceFunc } from 'vortec-components-front';
import icons from '@/icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationComponent',
  setup(__props) {

const navigationOpened = ref(false);

function includesName(outter: RouteRecordName | null | undefined, inner: string) {
  if (!outter) return false;
  const outterString = outter.toString();
  return outterString.includes(inner);
}

function logOutUser() {
  axios.post('/api/logout').then(() => {
    window.userData = null;
    router.push({ name: 'LoginPage' });
  });
}

const previousScrollY = ref(0);

let navigationElement: HTMLElement | null = null;
let tableRowElement: HTMLElement | null = null;
let subNavigation: HTMLElement | null = null;
let table: HTMLElement | null = null;

const cacheElements = () => {
  navigationElement = document.querySelector('.navigation-row');
  tableRowElement = document.querySelector('.table-row-header-movement');
  subNavigation = document.querySelector('.sub-navigation-row-movable');
  table = document.querySelector('.table') || document.querySelector('.grid-table');
};

const handleScroll = () => {
  cacheElements();
  if (!navigationElement) {
    return;
  }

  const scrollY = window.scrollY;
  const isScrollingUp = scrollY < previousScrollY.value;
  const headerHeight = navigationElement.clientHeight;
  const applyTransition = (element: HTMLElement, duration = '0.2s') => {
    element.style.transition = `transform ${duration}`;
  };

  const computedPosition = window.getComputedStyle(navigationElement).position;

  if (scrollY > headerHeight) {
    if (computedPosition !== 'sticky') {
      setTimeout(() => {
        if (!navigationElement) cacheElements();
        if (navigationElement) {
          navigationElement.style.position = 'sticky';
          applyTransition(navigationElement);
        }
      }, 200);
    }
    if (isScrollingUp) {
      navigationElement.style.transform = 'translateY(0)';
      applyTransition(navigationElement);
    } else {
      navigationElement.style.transform = 'translateY(-100%)';
      applyTransition(navigationElement);
    }
  } else if (scrollY <= 1) {
    navigationElement.style.position = 'relative';
    navigationElement.style.transition = 'none';
    navigationElement.style.transform = 'translateY(0)';
  }

  if (subNavigation) {
    const subNavigationHeight = subNavigation.clientHeight;
    const computedPosition = window.getComputedStyle(subNavigation).position;

    if (scrollY > headerHeight + subNavigationHeight) {
      if (computedPosition !== 'sticky') {
        setTimeout(() => {
          if (subNavigation) {
            subNavigation.style.position = 'sticky';
            applyTransition(subNavigation);
          }
        }, 200);
      }
      if (isScrollingUp) {
        subNavigation.style.transform = `translateY(${headerHeight}px)`;
      } else {
        subNavigation.style.transform = `translateY(-200%)`;
        subNavigation.style.transition = 'none';
      }
      applyTransition(subNavigation);
    } else if (scrollY >= headerHeight && scrollY <= headerHeight + subNavigationHeight) {
      if (isScrollingUp) {
        subNavigation.style.position = 'sticky';
        subNavigation.style.transform = `translateY(${subNavigationHeight}px)`;
      } else {
        subNavigation.style.transform = `translateY(-200%)`;
        subNavigation.style.transition = 'none';
      }
      applyTransition(subNavigation);
    } else if (scrollY <= headerHeight) {
      if (scrollY <= 1) {
        subNavigation.style.position = 'relative';
        subNavigation.style.transform = `translateY(0px)`;
        subNavigation.style.transition = 'none';
      } else if (computedPosition === 'sticky' && isScrollingUp) {
        subNavigation.style.position = 'sticky';
        subNavigation.style.transform = `translateY(${scrollY}px)`;

        applyTransition(subNavigation);
      }
    }
  }

  if (tableRowElement) {
    const topHeight = navigationElement.clientHeight + (subNavigation ? subNavigation.clientHeight : 0);
    let desiredTranslate = 0;

    if (isScrollingUp) {
      if (table) {
        const tableTop = table.getBoundingClientRect().top;
        if (tableTop > 0) {
          desiredTranslate = Math.max(0, topHeight - tableTop);
        } else {
          desiredTranslate = topHeight;
        }
      }
      tableRowElement.style.transform = `translateY(${desiredTranslate}px)`;

      applyTransition(tableRowElement);
    } else {
      tableRowElement.style.transform = 'translateY(0)';
      tableRowElement.style.transition = 'none';
    }

    if (desiredTranslate === 0) {
      tableRowElement.classList.remove('box-shadow-bottom');
    } else if (!tableRowElement.classList.contains('box-shadow-bottom')) {
      tableRowElement.classList.add('box-shadow-bottom');
    }
  }

  previousScrollY.value = scrollY;
};

onMounted(() => {
  window.addEventListener('scroll', useDebounceFunc(handleScroll, 25), { passive: true });
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: {
          name: 'PoliciesView',
        },
        class: "navigation-menu-box-logo"
      }, {
        default: _withCtx(() => [
          (
            _ctx.window.userData &&
            _ctx.window.userData.tenant &&
            _ctx.window.userData.tenant.logo &&
            _ctx.window.userData.tenant.logo?.file_data
          )
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.window.userData.tenant.logo.file_data.toString()
              }, null, 8, _hoisted_3))
            : (
            _ctx.window.userData &&
            _ctx.window.userData.tenant &&
            _ctx.window.userData.tenant.icon &&
            _ctx.window.userData.tenant.icon?.file_data
          )
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.window.userData.tenant.icon.file_data.toString()
                }, null, 8, _hoisted_4))
              : (_openBlock(), _createElementBlock("img", _hoisted_5))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: {
            name: 'PoliciesView',
          },
          class: _normalizeClass([{
            'active-navigation-list-item': includesName(_ctx.$route.name, 'Policies') || includesName(_ctx.$route.name, 'Policy'),
          }, "list-text-bold disabled-text"])
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode(" Полиси ")
          ])),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          to: {
            name: 'InsureesView',
          },
          class: _normalizeClass([{
            'active-navigation-list-item': includesName(_ctx.$route.name, 'Insuree'),
          }, "list-text-bold disabled-text"])
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [
            _createTextVNode(" Осигуреници ")
          ])),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          to: {
            name: 'DataAdder',
          },
          class: _normalizeClass([{
            'active-navigation-list-item': includesName(_ctx.$route.name, 'DataAdder'),
          }, "list-text-bold disabled-text"])
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [
            _createTextVNode(" Менаџирање со податоци ")
          ])),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          to: {
            name: 'FAQsManagement',
          },
          class: _normalizeClass([{
            'active-navigation-list-item': includesName(_ctx.$route.name, 'FAQsManagement'),
          }, "list-text-bold disabled-text"])
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [
            _createTextVNode(" ЧПП ")
          ])),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          to: {
            name: 'ContactDetailsManagement',
          },
          class: _normalizeClass([{
            'active-navigation-list-item': includesName(_ctx.$route.name, 'ContactDetailsManagement'),
          }, "list-text-bold disabled-text"])
        }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [
            _createTextVNode(" Контакт детали ")
          ])),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          to: {
            name: 'StatisticsView',
          },
          class: _normalizeClass([{
            'active-navigation-list-item': includesName(_ctx.$route.name, 'StatisticsView'),
          }, "list-text-bold disabled-text"])
        }, {
          default: _withCtx(() => _cache[19] || (_cache[19] = [
            _createTextVNode(" Статистика ")
          ])),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["hamburger", {
        'hamburger-menu-opened': navigationOpened.value,
      }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (navigationOpened.value = true))
    }, _cache[20] || (_cache[20] = [
      _createElementVNode("div", { class: "block" }, null, -1),
      _createElementVNode("div", { class: "block" }, null, -1),
      _createElementVNode("div", { class: "block" }, null, -1)
    ]), 2),
    _createVNode(_Transition, { name: "navigation-component-hamburger-list-animation" }, {
      default: _withCtx(() => [
        (navigationOpened.value)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_router_link, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (navigationOpened.value = false)),
                  to: {
              name: 'ClientSelection',
            },
                  class: _normalizeClass([{
              'active-navigation-list-item': includesName(_ctx.$route.name, 'ClientSelection'),
            }, "navigation-component-hamburger-list-options-option list-text-bold disabled-text"])
                }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createTextVNode(" Селектор на клиенти ")
                  ])),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (navigationOpened.value = false)),
                  to: {
              name: 'PoliciesView',
            },
                  class: _normalizeClass([{
              'active-navigation-list-item':
                includesName(_ctx.$route.name, 'Policies') || includesName(_ctx.$route.name, 'Policy'),
            }, "navigation-component-hamburger-list-options-option navigation-component-hamburger-list-options-option-desktop list-text-bold disabled-text"])
                }, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createTextVNode(" Полиси ")
                  ])),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (navigationOpened.value = false)),
                  to: {
              name: 'InsureesView',
            },
                  class: _normalizeClass([{
              'active-navigation-list-item': includesName(_ctx.$route.name, 'Insuree'),
            }, "navigation-component-hamburger-list-options-option navigation-component-hamburger-list-options-option-desktop list-text-bold disabled-text"])
                }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createTextVNode(" Осигуреници ")
                  ])),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (navigationOpened.value = false)),
                  to: {
              name: 'DataAdder',
            },
                  class: _normalizeClass([{
              'active-navigation-list-item': includesName(_ctx.$route.name, 'DataAdder'),
            }, "navigation-component-hamburger-list-options-option navigation-component-hamburger-list-options-option-desktop list-text-bold disabled-text"])
                }, {
                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                    _createTextVNode(" Менаџирање со податоци ")
                  ])),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (navigationOpened.value = false)),
                  to: {
              name: 'FAQsManagement',
            },
                  class: _normalizeClass([{
              'active-navigation-list-item': includesName(_ctx.$route.name, 'FAQsManagement'),
            }, "navigation-component-hamburger-list-options-option navigation-component-hamburger-list-options-option-desktop list-text-bold disabled-text"])
                }, {
                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                    _createTextVNode(" ЧПП ")
                  ])),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (navigationOpened.value = false)),
                  to: {
              name: 'ContactDetailsManagement',
            },
                  class: _normalizeClass([{
              'active-navigation-list-item': includesName(_ctx.$route.name, 'ContactDetailsManagement'),
            }, "navigation-component-hamburger-list-options-option navigation-component-hamburger-list-options-option-desktop list-text-bold disabled-text"])
                }, {
                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                    _createTextVNode(" Контакт детали ")
                  ])),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (navigationOpened.value = false)),
                  to: {
              name: 'StatisticsView',
            },
                  class: _normalizeClass([{
              'active-navigation-list-item': includesName(_ctx.$route.name, 'StatisticsView'),
            }, "navigation-component-hamburger-list-options-option navigation-component-hamburger-list-options-option-desktop list-text-bold disabled-text"])
                }, {
                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                    _createTextVNode(" Статистика ")
                  ])),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (navigationOpened.value = false)),
                  to: {
              name: 'ProfileView',
            },
                  class: _normalizeClass([{
              'active-navigation-list-item': includesName(_ctx.$route.name, 'Profile'),
            }, "navigation-component-hamburger-list-options-option list-text-bold disabled-text"])
                }, {
                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                    _createTextVNode(" Профил ")
                  ])),
                  _: 1
                }, 8, ["class"]),
                (_ctx.window.userData && _ctx.window.userData.scopes.includes('user-management'))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (navigationOpened.value = false)),
                      to: {
              name: 'UsersView',
            },
                      class: _normalizeClass([{
              'active-navigation-list-item': includesName(_ctx.$route.name, 'User'),
            }, "navigation-component-hamburger-list-options-option list-text-bold disabled-text"])
                    }, {
                      default: _withCtx(() => _cache[29] || (_cache[29] = [
                        _createTextVNode(" Корисници ")
                      ])),
                      _: 1
                    }, 8, ["class"]))
                  : _createCommentVNode("", true),
                (_ctx.window.userData && _ctx.window.userData.scopes.includes('system-administrator'))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (navigationOpened.value = false)),
                      to: {
              name: 'ActivityLogsView',
            },
                      class: _normalizeClass([{
              'active-navigation-list-item': includesName(_ctx.$route.name, 'ActivityLogsView'),
            }, "navigation-component-hamburger-list-options-option list-text-bold disabled-text"])
                    }, {
                      default: _withCtx(() => _cache[30] || (_cache[30] = [
                        _createTextVNode(" Активности ")
                      ])),
                      _: 1
                    }, 8, ["class"]))
                  : _createCommentVNode("", true),
                (_ctx.window.userData && _ctx.window.userData.scopes.includes('system-administrator'))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 2,
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (navigationOpened.value = false)),
                      to: {
              name: 'ClientsView',
            },
                      class: _normalizeClass([{
              'active-navigation-list-item': includesName(_ctx.$route.name, 'Clients'),
            }, "navigation-component-hamburger-list-options-option list-text-bold disabled-text"])
                    }, {
                      default: _withCtx(() => _cache[31] || (_cache[31] = [
                        _createTextVNode(" Клиенти ")
                      ])),
                      _: 1
                    }, 8, ["class"]))
                  : _createCommentVNode("", true),
                (_ctx.window.userData && _ctx.window.userData.scopes.includes('system-administrator'))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 3,
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (navigationOpened.value = false)),
                      to: {
              name: 'ScopesManagement',
            },
                      class: _normalizeClass([{
              'active-navigation-list-item': includesName(_ctx.$route.name, 'ScopesManagement'),
            }, "navigation-component-hamburger-list-options-option list-text-bold disabled-text"])
                    }, {
                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                        _createTextVNode(" Привилегии ")
                      ])),
                      _: 1
                    }, 8, ["class"]))
                  : _createCommentVNode("", true),
                (_ctx.window.userData && _ctx.window.userData.scopes.includes('system-administrator'))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 4,
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (navigationOpened.value = false)),
                      to: {
              name: 'LogsView',
            },
                      class: "navigation-component-hamburger-list-options-option list-text-bold disabled-text"
                    }, {
                      default: _withCtx(() => _cache[33] || (_cache[33] = [
                        _createTextVNode(" Логови ")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _cache[36] || (_cache[36] = _createElementVNode("a", {
                  href: "https://cdn.triglav.vortec.io/manuals/dzo_manual.pdf",
                  target: "_blank",
                  class: "navigation-component-hamburger-list-options-option list-text-bold disabled-text"
                }, " Упатство за администратори ", -1)),
                _cache[37] || (_cache[37] = _createElementVNode("a", {
                  href: "https://cdn.triglav.vortec.io/manuals/dzo_manual_client.pdf",
                  target: "_blank",
                  class: "navigation-component-hamburger-list-options-option list-text-bold disabled-text"
                }, " Упатство за клиенти ", -1)),
                _createElementVNode("div", {
                  class: "navigation-component-hamburger-list-options-option navigation-component-hamburger-list-options-option-logout list-text-bold disabled-text",
                  onClick: logOutUser
                }, [
                  _cache[34] || (_cache[34] = _createTextVNode(" Одјави се ")),
                  _createElementVNode("div", {
                    innerHTML: _unref(icons).logoutIcon
                  }, null, 8, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, " © " + _toDisplayString(new Date().getFullYear()) + " Vortec | Сите права се задржани ", 1),
                  _cache[35] || (_cache[35] = _createElementVNode("p", { class: "info-text upper-case-text center-text" }, [
                    _createTextVNode(" Изработено од "),
                    _createElementVNode("a", {
                      href: "https://vortec.io",
                      class: "vortec-text upper-case-text info-text-bold"
                    }, "Vortec")
                  ], -1))
                ])
              ])
            ])), [
              [_directive_click_outside, 
          () => {
            navigationOpened.value = false;
          }
        ]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})